export const BUSINESS_IDENTITY = {
  brandName: 'Dialgia Group',
  legalName: 'EDPLX Limited',
  tradingName: 'Dialgia Group',
  companyNumber: '15398152',
  website: 'https://www.dialgia.com',
  email: 'hello@dialgia.com',
  legalEmail: 'legal@dialgia.com',
  privacyEmail: 'privacy@dialgia.com',
  dpoEmail: 'dpo@dialgia.com',
  address: {
    streetAddress: '124 City Road',
    addressLocality: 'London',
    addressRegion: 'England',
    postalCode: 'EC1V 2NX',
    addressCountry: 'GB',
    countryName: 'United Kingdom',
  },
  officePhone: {
    display: '+44 (0) 844 884 5150',
    e164: '+448448845150',
    href: 'tel:+448448845150',
  },
  whatsapp: {
    display: '+44 (0) 7521 45 44 18',
    compactDisplay: '+44 7521 454418',
    internationalNumber: '447521454418',
    e164: '+447521454418',
    href: 'https://wa.me/447521454418',
  },
  social: {
    x: 'https://x.com/dialgiagroup',
    xHandle: '@dialgiagroup',
    linkedin: 'https://www.linkedin.com/company/dialgia',
    github: 'https://github.com/dialgia',
    facebook: 'https://www.facebook.com/dialgiagroup',
  },
  businessHours: {
    display: 'Mon-Fri: 9:00 AM - 6:00 PM GMT',
    opens: '09:00',
    closes: '18:00',
  },
} as const;

export const BUSINESS_ADDRESS_LINES = [
  BUSINESS_IDENTITY.address.streetAddress,
  `${BUSINESS_IDENTITY.address.addressLocality}, ${BUSINESS_IDENTITY.address.postalCode}`,
  BUSINESS_IDENTITY.address.countryName,
] as const;
